import { useContext, createContext, useReducer } from 'react';

const SimaTechContext = createContext()
const State = { vehicleId: null, vehicleName: null }

function SimaTechReducer(state, action) {
  switch (action.type) {          
    case 'vehicleId': {
      return { ...state, vehicleId: action.payload }
    }              
    case 'vehicleName': {
      return { ...state, vehicleName: action.payload }
    }            
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function SimaTechProvider({ children }) {
  const [state, dispatch] = useReducer(SimaTechReducer, State)
  // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context
  const value = { state, dispatch }
  return <SimaTechContext.Provider value={value}>{children}</SimaTechContext.Provider>
}

function useSimaTechContext() {
  const context = useContext(SimaTechContext)
  if (context === undefined) {
    throw new Error('SimaTechContext must be used within a SimaTechProvider')
  }
  return context
}

export { SimaTechProvider, useSimaTechContext }